/* Recently viewed products: stores product handles on product pages (max 8, newest first) and renders [data-recently-viewed] sections. */
(() => {
  'use strict';
  const Purr = window.Purr;
  if (Purr.recentlyViewed) return;
  const KEY = 'purr_recently_viewed';
  const MAX = 8;
  const read = () => { try { const v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } };
  const write = (list) => { try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) { /* ignore */ } };
  Purr.recentlyViewed = {
    get: read,
    add(handle) { if (!handle) return; write([handle, ...read().filter((h) => h !== handle)]); },
    clear() { write([]); }
  };

  // Nothing to show: keep the section root (the theme editor needs it) but hide its content.
  // In the editor, show the placeholder hint instead so the merchant can find the section.
  const showEmpty = (section) => {
    const content = section.querySelector('[data-recently-viewed-content]');
    const hint = section.querySelector('[data-recently-viewed-hint]');
    if (content) content.hidden = true;
    if (window.Shopify && window.Shopify.designMode && hint) {
      hint.hidden = false;
      section.hidden = false;
    } else {
      section.hidden = true;
    }
  };

  const render = async () => {
    const sections = document.querySelectorAll('[data-recently-viewed]:not([data-loaded])');
    if (!sections.length || !Purr.loadProducts || !Purr.renderCard) return;
    for (const section of sections) {
      section.dataset.loaded = 'true';
      const exclude = section.dataset.exclude;
      const limit = parseInt(section.dataset.limit, 10) || 4;
      const handles = read().filter((h) => h !== exclude).slice(0, limit);
      const grid = section.querySelector('[data-recently-viewed-grid]');
      if (!handles.length || !grid) { showEmpty(section); continue; }
      const products = (await Purr.loadProducts(handles)) || [];
      if (!products.length) { showEmpty(section); continue; }
      products.forEach((p) => { const card = Purr.renderCard(p); if (card) grid.appendChild(card); });
      section.hidden = false;
      Purr.initReveal && Purr.initReveal();
    }
  };

  const handle = document.body && document.body.dataset.productHandle;
  // Render before adding the current product so it is not shown to itself on the same page.
  Purr.ready(() => { render().then(() => { if (handle) Purr.recentlyViewed.add(handle); }); });
  document.addEventListener('shopify:section:load', render);
})();
